export default __webpack_public_path__ + "static/media/grafema_the-essence-collective_08.05e80f97.jpg";